var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-page-base',{attrs:{"has-header":true,"has-sidebar":true}},[_c('div',{staticClass:"p-32 overflow-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }